// The rough edit never goes to a client (backend app/rough_edit.py). On a highlight or a social order that was given
// a prep package, the portal reads each project file and asset an editor uploads, as it lands; these are the two
// refusals it answers with: the file still holds the timeline, or it could not be read through.
export const REFUSALS = ['rough_edit_in_file', 'file_not_checked'];

// The refusal's words out of a failed check, or null when it failed for any other reason (the check could not be
// reached, storage did not answer). Only a refusal stops a file: on anything else the file goes on to the draft, and
// the draft's submit asks the same question again (that route is the guarantee, this is the early word).
export function refusalOf(error) {
  const d = error?.response?.data?.detail;
  return d && typeof d === 'object' && REFUSALS.includes(d.code) && typeof d.message === 'string' && d.message
    ? d.message : null;
}

// Does this upload get the check? An editor's project files and assets; a review video is not a project file, the
// timeline XML never reaches a client (backend app/edit_xml.py), and admin and staff are not asked (the server asks
// nothing of them either).
export function asksCheck(role, fileType) {
  return role === 'editor' && fileType !== 'review_video' && fileType !== 'edit_xml';
}
